import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSubscription } from '../contexts/SubscriptionContext';

const CheckoutGuard = ({ children }) => {
  const { subscriptionStatus, loading } = useSubscription();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (subscriptionStatus === 'premium' || subscriptionStatus === 'canceling') {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

export default CheckoutGuard;